<template>
	<div v-if="chartOptions.series[0].data[0].name != ''" id="test2" :options="chartOptions" @click="onClickBuble">
  </div>
  <div v-else id="test2" :options="chartOptions" @click="onClickBuble">
  </div>
</template>

<script>
	import HighCharts from 'highcharts';
	import highchartsMore from 'highcharts/highcharts-more';
	highchartsMore(HighCharts);
  // import axios from "axios";
	export default {
    props: {
      selectedTopic: null,
      selectedPeriode: null,
      selectedTopic2: null,
      statusFilter: null,
      isClickBubleOrg: null,
      isClickWord: null,
      resetcolorClicked: null,
      updateSocket: null
    },
		data() {
			return {
        isClickBuble: "",
        colorClicked: "",
				id: 'test2',
        dialog: false,
        SetPerson: [],
        chart_data_sort: [],
				chartOptions: {
					chart: {
						type: 'packedbubble',
						height: '309px'
					},
					title: {
            text: null
          },
					tooltip: {
						enabled: false
					},
					legend: {
						enabled: false
					},
					credits: {
						enabled: false
					},
          series: [
            {
              data: [{
                value: 0,
                name: ''
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'gray'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'pink'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'yellow'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'green'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'purple'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'red'
              }]
            },
            {
              data: [{
                value: 0,
                name: '',
                color: 'black'
              }]
            },
          ],

          plotOptions: {
            packedbubble: {
              minSize: '40%',
              maxSize: '120%',
              zMin: 0,
              zMax: 1000,
              layoutAlgorithm: {
                splitSeries: false,
                gravitationalConstant: 0.02
              },
              dataLabels: {
                enabled: true,
                format: '{point.name}',
                useHTML: true,
                style: {
                  textAlign: 'center',
                  textOverflow: 'clip',
                  width: 100,
                  color: 'black',
                  textOutline: 'none',
                  fontWeight: 'normal'
                },
              }
            }
          },
				},
			}
		},
		mounted() {
			// this.option.series = this.seriesData;
      HighCharts.chart(this.id, this.chartOptions);
    },
		updated() {
			HighCharts.chart(this.id, this.chartOptions);
		},
    methods: {
      onClickBuble(event) {
        this.isClickBuble = event.point.name;
        console.log(event.point.color);
        this.colorClicked = event.point.color;
        this.$emit('clicked', this.isClickBuble);
      },
      async generatebubble() {
        this.MediatwitterShare = [];
        HighCharts.chart(this.id, this.chartOptions);
        if (this.updateSocket == false) {
          this.dialog = true;
        }
        // try {
            const bubble_data = this.$store.bubble_data;
            // console.log(bubble_data)
            const person = [];
            const person2 = [];
            bubble_data.forEach((element) => {
              if (element["name"] != '' && element["name"] != null) {
                person.push(element["name"]);
                person2.push(element["name"]);
              }
            });
            this.SetPerson = [...new Set(person)];
            this.chart_data_sort = [];
            for (let x = 0; x < this.SetPerson.length; x++) {
              this.chart_data_sort.push({
                'name_organization' : this.SetPerson[x],
                'name_organization_value' : bubble_data[x].count
              })
            }
            this.chart_data_sort.sort(function(a,b) { // sort desc value
              return (b.name_organization_value) - (a.name_organization_value);
            });
            // for (let i = 0; i < 6; i++) {
            //   console.log( 'aaaa')

            //   this.chartOptions.series[i].data[0].name = "";
            //   this.chartOptions.series[i].data[0].value = 0;
            // }
            if (this.SetPerson.length == 0) {
              for (let i = 0; i < 6; i++) {

                this.chartOptions.series[i].data[0].name = "";
                this.chartOptions.series[i].data[0].value = 0;
              }
            }

            if (this.SetPerson.length != 0) {
              for (let x = 0; x < this.chart_data_sort.length; x++) {
            // console.log(this.chart_data_sort[x].name_organization)

                if (x < this.chart_data_sort.length) {
                  var cont = 250;
                  if(x == 0){cont = 1000}
                  if(x == 1){cont = 900}
                  if(x == 2){cont = 700}
                  if(x == 3){cont = 550}
                  if(x == 4){cont = 400}
                  if(x == 5){cont = 300}
                  
                  // console.log(this.chartOptions.series[x].data[0].name);
                  this.chartOptions.series[x].data[0].name = this.chart_data_sort[x].name_organization;
                  this.chartOptions.series[x].data[0].value =cont;
                  // this.chartOptions.series[x].data[0].value = Math.ceil(300 / this.chartOptions.series.length * this.chart_data_sort[x].name_organization_value);
                }
              }
            }

          this.dialog = false;
        // } catch(e) {
        //   this.dialog = false;
        //   console.log('error');
        //   console.log(e);
        // }
      },
    },
	};
</script>